"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("@powerednow/complexData/entity");
const date_1 = require("@powerednow/shared/modules/utilities/date");
let DocumentWithHeadersEntity = class DocumentWithHeadersEntity extends entity_1.EntityWithCompanyId {
};
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true })
], DocumentWithHeadersEntity.prototype, "id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentWithHeadersEntity.prototype, "type", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentWithHeadersEntity.prototype, "status", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', allowNull: true, codeName: 'documentNumber' })
], DocumentWithHeadersEntity.prototype, "documentnumber", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', codeName: 'displayNumber' })
], DocumentWithHeadersEntity.prototype, "displaynumber", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', codeName: 'taxPoint', dbType: 'date' })
], DocumentWithHeadersEntity.prototype, "taxpoint", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date', defaultValue: date_1.getNow })
], DocumentWithHeadersEntity.prototype, "dt_created", void 0);
__decorate([
    (0, entity_1.field)({ defaultValue: 0, type: 'float' })
], DocumentWithHeadersEntity.prototype, "subtotal", void 0);
__decorate([
    (0, entity_1.field)({ defaultValue: 0, type: 'float' })
], DocumentWithHeadersEntity.prototype, "vat", void 0);
__decorate([
    (0, entity_1.field)({ defaultValue: 0, type: 'float' })
], DocumentWithHeadersEntity.prototype, "total", void 0);
__decorate([
    (0, entity_1.field)({ defaultValue: 0, type: 'float' })
], DocumentWithHeadersEntity.prototype, "accepted", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', codeName: 'refuseReason' })
], DocumentWithHeadersEntity.prototype, "refusereason", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentWithHeadersEntity.prototype, "job_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true, serverOnly: true })
], DocumentWithHeadersEntity.prototype, "company_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], DocumentWithHeadersEntity.prototype, "uuid", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentWithHeadersEntity.prototype, "customer_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentWithHeadersEntity.prototype, "action_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentWithHeadersEntity.prototype, "user_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], DocumentWithHeadersEntity.prototype, "template_path", void 0);
__decorate([
    (0, entity_1.field)({ defaultValue: 1, type: 'int' })
], DocumentWithHeadersEntity.prototype, "layout_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], DocumentWithHeadersEntity.prototype, "display_total", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentWithHeadersEntity.prototype, "parent_document_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', codeName: 'isDeleted', serverOnly: true })
], DocumentWithHeadersEntity.prototype, "isdeleted", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', dbType: 'date', serverOnly: true, defaultValue: null, allowNull: true,
    })
], DocumentWithHeadersEntity.prototype, "dt_deleted", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], DocumentWithHeadersEntity.prototype, "confirmed", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], DocumentWithHeadersEntity.prototype, "printed", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: null, allowNull: true })
], DocumentWithHeadersEntity.prototype, "prefix", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: null, allowNull: true })
], DocumentWithHeadersEntity.prototype, "suffix", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', codeName: 'isLocked', defaultValue: false })
], DocumentWithHeadersEntity.prototype, "islocked", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentWithHeadersEntity.prototype, "consumption_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: false })
], DocumentWithHeadersEntity.prototype, "is_disbursement", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: null })
], DocumentWithHeadersEntity.prototype, "reminders_disabled", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: false })
], DocumentWithHeadersEntity.prototype, "is_cis", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float', defaultValue: 0 })
], DocumentWithHeadersEntity.prototype, "cis_total", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float', defaultValue: 0 })
], DocumentWithHeadersEntity.prototype, "cisable_amount", void 0);
__decorate([
    (0, entity_1.field)({ type: 'float', defaultValue: 0 })
], DocumentWithHeadersEntity.prototype, "cis_estimate", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date' })
], DocumentWithHeadersEntity.prototype, "dt_locked", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentWithHeadersEntity.prototype, "external_company_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentWithHeadersEntity.prototype, "external_document_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: false })
], DocumentWithHeadersEntity.prototype, "external_clone", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', codeName: 'isArchived', serverOnly: true })
], DocumentWithHeadersEntity.prototype, "is_archived", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', dbType: 'date', serverOnly: true, defaultValue: null, allowNull: true,
    })
], DocumentWithHeadersEntity.prototype, "dt_archived", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'storageUrl', type: 'string' })
], DocumentWithHeadersEntity.prototype, "storage_url", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], DocumentWithHeadersEntity.prototype, "plot", void 0);
__decorate([
    (0, entity_1.field)({
        codeName: 'lastActivity',
        minAppVersion: '7.7.0',
        type: 'string',
        dbType: 'date',
        defaultValue: date_1.getNow,
    })
], DocumentWithHeadersEntity.prototype, "lastActivity", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date', minAppVersion: '7.7.0' })
], DocumentWithHeadersEntity.prototype, "dueDate", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', allowNull: true })
], DocumentWithHeadersEntity.prototype, "vat_return_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', minAppVersion: '7.7.3' })
], DocumentWithHeadersEntity.prototype, "summary", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'boolean', defaultValue: false, clientOnly: true, minAppVersion: '7.9.0',
    })
], DocumentWithHeadersEntity.prototype, "bulkCreated", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: null })
], DocumentWithHeadersEntity.prototype, "accounting_reference", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: null })
], DocumentWithHeadersEntity.prototype, "sync_uuid", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: null })
], DocumentWithHeadersEntity.prototype, "synced_uuid", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', defaultValue: null })
], DocumentWithHeadersEntity.prototype, "customer_content_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', defaultValue: null })
], DocumentWithHeadersEntity.prototype, "company_content_id", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'JobDescription', type: 'int' })
], DocumentWithHeadersEntity.prototype, "JobDescription", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'JobIsDeleted', type: 'boolean' })
], DocumentWithHeadersEntity.prototype, "JobIsDeleted", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'CustomerId', type: 'int' })
], DocumentWithHeadersEntity.prototype, "CustomerId", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'CustomerCompany', type: 'string' })
], DocumentWithHeadersEntity.prototype, "CustomerCompany", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'CustomerContactId', type: 'int' })
], DocumentWithHeadersEntity.prototype, "CustomerContactId", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'CustomerContactLastName', type: 'string' })
], DocumentWithHeadersEntity.prototype, "CustomerContactLastName", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'CustomerContactFirstName', type: 'string' })
], DocumentWithHeadersEntity.prototype, "CustomerContactFirstName", void 0);
__decorate([
    (0, entity_1.field)({ codeName: 'CustomerName', type: 'string' })
], DocumentWithHeadersEntity.prototype, "CustomerName", void 0);
DocumentWithHeadersEntity = __decorate([
    entity_1.EntityDecorator
], DocumentWithHeadersEntity);
exports.default = DocumentWithHeadersEntity;
//# sourceMappingURL=../../../../src/models/documentWithHeaders/entity.js.map